import React, { useState } from 'react';
import { Mail, Phone, MapPin, Clock, Send, MessageSquare, HeadphonesIcon } from 'lucide-react';
// import components
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
        // Add your form submission logic here
        alert('Thank you for contacting us! We will get back to you soon.');
        setFormData({
            name: '',
            email: '',
            phone: '',
            subject: '',
            message: ''
        });
    };

    const contactInfo = [
        {
            icon: Phone,
            title: 'Phone',
            details: '+91 98765 43210',
            subdetails: 'Mon-Sat, 9AM-6PM'
        },
        {
            icon: Mail,
            title: 'Email',
            details: 'support@gatewaypromoters.com',
            subdetails: 'We reply within 24 hours'
        },
        {
            icon: MapPin,
            title: 'Office',
            details: 'Gateway Promoters HQ',
            subdetails: 'Chennai, Tamil Nadu, India'
        },
        {
            icon: Clock,
            title: 'Working Hours',
            details: 'Monday - Saturday',
            subdetails: '9:00 AM - 6:00 PM'
        }
    ];

    return (
        <div className="min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900">
            {/* Hero Section */}
            <div className="relative overflow-hidden">
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-20 right-20 w-96 h-96 bg-cyan-500 rounded-full filter blur-3xl"></div>
                    <div className="absolute bottom-20 left-20 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl"></div>
                </div>
                <Header />
                <div className="relative z-10 px-6 py-20">
                    <div className="max-w-7xl mx-auto text-center">
                        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
                            Get in <span className="text-cyan-400">Touch</span>
                        </h1>
                        <p className="text-xl text-gray-300 max-w-2xl mx-auto">
                            Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
                        </p>
                    </div>
                </div>
            </div>

            {/* Contact Info Cards */}
            <div className="px-6 py-12">
                <div className="max-w-7xl mx-auto">
                    <div className="grid md:grid-cols-4 gap-6">
                        {contactInfo.map((info, index) => {
                            const Icon = info.icon;
                            return (
                                <div
                                    key={index}
                                    className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-6 border border-cyan-500/20 hover:border-cyan-500/50 transition-all text-center"
                                >
                                    <div className="w-14 h-14 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                                        <Icon className="w-7 h-7 text-white" />
                                    </div>
                                    <h3 className="text-lg font-bold text-white mb-2">{info.title}</h3>
                                    <p className="text-cyan-400 font-semibold mb-1">{info.details}</p>
                                    <p className="text-gray-400 text-sm">{info.subdetails}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* Contact Form Section */}
            <ContactForm />
            <Footer />
        </div>
    );
};

export default ContactUs;